"use client"

import clsx from "clsx"

import { Spinner } from "~/components/abstracts/Spinner"

import * as css from "./styles.css"

export interface LoadingPageProps {
  className?: string
  color?: string
}

function LoadingPage({ color, className }: LoadingPageProps) {
  return (
    <section className={clsx(css.loader, className)}>
      <Spinner className={css.spinner} width={40} color={color} />
    </section>
  )
}

export { LoadingPage }
